import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const ErrorBoundary = ({ error, withContactSupport = false }) => {
  const { t } = useTranslation()

  return (
    <div className='my-40'>
      <div className='text-center'>
        <p className='text-base font-medium text-indigo-600'>{t('error')}</p>
        <h1 className='mt-2 text-lg font-medium text-gray-900 tracking-tight'>
          {t('error_title')}
        </h1>
        <p className='mt-8 text-xl font-bold text-gray-900'>{t(error)}</p>
        {withContactSupport && (
          <div className='mt-12'>
            <a
              href={t('contact_support_mailto')}
              className='text-base font-medium text-indigo-600 hover:text-indigo-500'
            >
              {t('contact_support_action')}
              <span aria-hidden='true'> &rarr;</span>
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

ErrorBoundary.propTypes = {
  error: PropTypes.string.isRequired,
  withContactSupport: PropTypes.bool
}

export default ErrorBoundary
